import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ExperimentRepository } from "../../domain/interfaces/ExperimentRepository";
import { ExperimentFilters, ExperimentListItem } from "../../domain/experiment.entity";
import { experimentsQueryKeys } from "../../infrastructure/cache/ExperimentsCacheStrategy";

interface UseExperimentsOptions {
  enabled?: boolean;
}

export function useExperiments(
  propertyTicker: string,
  filters: ExperimentFilters,
  repository: ExperimentRepository,
  { enabled = true }: UseExperimentsOptions = {}
) {
  return useQuery({
    queryKey: experimentsQueryKeys.list(propertyTicker, filters),
    queryFn: (): Promise<ExperimentListItem[]> => repository.list(filters),
    enabled,
    placeholderData: keepPreviousData, // AC4: keep showing the previous page while refetching
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
